import React from 'react';
import Tilt from 'react-parallax-tilt';
import { useReducedMotion } from 'framer-motion';

// Real 3D perspective tilt (rotateX/rotateY driven by cursor position) plus a
// moving glare highlight, so cards read as physical tilted glass/cards rather
// than flat divs. Falls back to a static wrapper when reduced motion is set.
export default function TiltCard({
  children,
  glareColor = '#FD8112',
  glareOpacity = 0.18,
  maxTilt = 10,
  scale = 1.02,
  style,
  ...props
}) {
  const prefersReducedMotion = useReducedMotion();

  if (prefersReducedMotion) {
    return (
      <div style={{ height: '100%', ...style }} {...props}>
        {children}
      </div>
    );
  }

  return (
    <Tilt
      tiltMaxAngleX={maxTilt}
      tiltMaxAngleY={maxTilt}
      perspective={1000}
      scale={scale}
      transitionSpeed={1200}
      glareEnable
      glareMaxOpacity={glareOpacity}
      glareColor={glareColor}
      glarePosition="all"
      glareBorderRadius="20px"
      style={{ height: '100%', ...style }}
      {...props}
    >
      {children}
    </Tilt>
  );
}
